import type { Data } from '@ori-events/user-action';
import { dispatch } from '@ori-events/user-action';

export const DATA_ORI_EVENTS_USER_ACTION = '[data-ori-events-user-action]';

export function init(): void {
  const links = [...document.querySelectorAll<HTMLElement>(DATA_ORI_EVENTS_USER_ACTION)];

  links.forEach((link: HTMLElement) => {
    if (link.dataset.isUserActionInitialized) {
      return;
    }
    link.addEventListener('click', () => {
      const { oriEventsUserAction } = link.dataset;
      if (!oriEventsUserAction) {
        return;
      }
      const { metaHierarchy, numberValue } = JSON.parse(oriEventsUserAction) as Data;
      dispatch(metaHierarchy, numberValue);
    });
    // eslint-disable-next-line no-param-reassign -- x
    link.dataset.isUserActionInitialized = '1';
  });
}
